import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class ProjectsStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
}

